var _defs, _polygon, _polygon2, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModelingSubSurfaceSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "xaml",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#363545;}.cls-2{fill:#aeaeb6;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ModelingSubSurface_svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "16 17.25 7.66 13.12 1.84 16 16 23.02 30.16 16 24.34 13.12 16 17.25"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "16 25.23 7.66 21.1 1.84 23.98 16 31 30.16 23.98 24.34 21.1 16 25.23"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.72,7.27a17.29,17.29,0,0,1-10,.27,20.86,20.86,0,0,1-2.4-1C15.18,6,14.54,5.75,14,6s-.6.5-.93,1.37a5.9,5.9,0,0,1-1.84,2.85,6.16,6.16,0,0,1-2.64,1.13l2.12,1c2.32-2.23,4.5-3.27,6.49-3.07a8,8,0,0,1,2.46.77,7.82,7.82,0,0,0,3.39.85h0a7.53,7.53,0,0,0,1.56-.17L30.16,8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.82,11.89A6.41,6.41,0,0,0,17,11.28c-1.26-.13-2.73.56-4.38,2L16,15l4.79-2.38A12.62,12.62,0,0,1,18.82,11.89Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.94,8.61a4.13,4.13,0,0,0,1.22-2,3.67,3.67,0,0,1,2.12-2.55c1.37-.5,2.61.07,3.91.67a19.12,19.12,0,0,0,2.17.88,13.85,13.85,0,0,0,6.56.25L16,1,1.84,8,4.61,9.35C7.09,9.69,8.88,9.45,9.94,8.61Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelingSubSurfaceSvg);
export default __webpack_public_path__ + "static/media/ModelingSubSurface_svg.c78138f97f8f768eb5fc94919bf96f34.svg";
export { ForwardRef as ReactComponent };